import BuyerCategoryTrafficControlAPI from '@/api/buyer-category-traffic-control.api'

const state = {
  // Structure: { [buyerId-categoryId]: Array<{id: string, name: string}> }
  buyerAllowedSellers: {}
}


/**
* @type {import('vuex').GetterTree<typeof state>}
*/
const getters = {
  getAllowedSellers: state => (buyerId, categoryId) => {
    const key = `${buyerId}-${categoryId}`
    return state.buyerAllowedSellers[key] || []
  }
}


/**
* @type {import('vuex').ActionTree<typeof state>}
*/
const actions = {
  async fetchAllowedSellers({ commit }, { buyerId, categoryId }) {
    const response = await BuyerCategoryTrafficControlAPI.getAllowedSellers(buyerId, categoryId)

    commit('SET_ALLOWED_SELLERS', { 
      buyerId, 
      categoryId, 
      sellers: response.data || [] 
    })

    return response.data
  },
  
  async updateAllowedSellers({ commit }, { buyerId, categoryId, sellerIds }) {
    const response = await BuyerCategoryTrafficControlAPI.setAllowedSellers(buyerId, categoryId, sellerIds)

    commit('SET_ALLOWED_SELLERS', { 
      buyerId, 
      categoryId, 
      sellers: sellerIds.map(id => ({ id, name: '' })) 
    })

    return response.data
  }
}


/**
* @type {import('vuex').MutationTree<typeof state>}
*/
const mutations = {
  SET_ALLOWED_SELLERS(state, { buyerId, categoryId, sellers }) {
    const key = `${buyerId}-${categoryId}`

    state.buyerAllowedSellers = {
      ...state.buyerAllowedSellers,
      [key]: sellers
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}